<template>
  <div id="app">
    <!-- header -->
    <header
        id="header"
        :class="{
        'headroom--unpinned': scrolled,
        headroom: isScrolled,
        isTopHeader: isTopHeader,
      }"
    >
      <div class="box-call-center">
        <div class="container-fluid">
          <div class="call-center d-flex justify-content-between">
            <div class="item-call">
              <img
                  src="../assets/images/tel-phone-icon.png"
                  alt="icon"
              />
              <span>Колл-центр:</span>
            </div>
            <div class="item-call">
              <a href="tel:712000013">+998 71 200-00-13</a>
            </div>
          </div>
        </div>
      </div>
      <div class="container-navbar">
        <div class="container">
          <div class="row">
            <div
                class="nav-block d-flex justify-content-between align-items-center"
            >
              <div
                  class="logo-navbar d-flex justify-content-between align-items-center"
              >
                <i class="bi bi-list" @click="showMobileMenu"></i>
                <div class="dropdown">
                  <button
                      class="btn-vector"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                  >
                    <img
                        src="../assets/images/LogoServises/Vector-EDI.png"
                        alt="Vector"
                        class="Vector"
                    />
                  </button>
                  <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                  >
                    <!-- -------------------- -->

                    <div class="row">
                      <div class="col-lg-6">
                        <li class="InVector-item">
                          <a href="https://edo.faktura.uz/" target="_blank">
                            <img
                                src="../assets/images/edo.png"
                                alt="png"
                                class="vector-in-img"
                            />
                            <p class="InVector-description lng-InVector-edo">
                              {{
                                translation.translate("Home", "InVector-edo")
                              }}
                            </p>
                          </a>
                        </li>
                      </div>
                      <div class="col-lg-6">
                        <li class="InVector-item">
                          <a href="https://pay.faktura.uz" target="_blank">
                            <img
                                src="../assets/images/pay.png"
                                alt="png"
                                class="vector-in-img"
                            />
                            <p class="InVector-description lng-InVector-pay">
                              {{
                                translation.translate("Home", "InVector-pay")
                              }}
                            </p>
                          </a>
                        </li>
                      </div>
                      <div class="col-lg-6">
                        <li class="InVector-item">
                          <a href="https://botcrm.uz/" target="_blank">
                            <img
                                src="../assets/images/crm.png"
                                alt="png"
                                class="vector-in-img"
                            />
                            <p class="InVector-description lng-InVector-crm">
                              {{
                                translation.translate("Home", "InVector-crm")
                              }}
                            </p>
                          </a>
                        </li>
                      </div>
                      <div class="col-lg-6">
                        <li class="InVector-item">
                          <a href="https://edi.faktura.uz/" target="_blank">
                            <img
                                src="../assets/images/EDI-logo.png"
                                alt=""
                                class="vector-in-img"
                            />
                            <p class="InVector-description lng-InVector-edi">
                              {{
                                translation.translate("Home", "InVector-edi")
                              }}
                            </p>
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </div>
                <a href="/"
                ><img
                    src="../assets/images/LogoServises/EDILogo.png"
                    alt="logo"
                    class="logo"
                /></a>
              </div>
              <div
                  class="navbar-box d-flex align-items-center justify-content-between"
              >
                <ul class="box-menu">
                  <a href="#Possibilities"
                  ><li class="nav-item lng-possibilitiesNavbar">
                    {{ translation.translate("Home", "possibilitiesNavbar") }}
                  </li></a
                  >
                  <a href="#Peculiarities"
                  ><li class="nav-item lng-peculiaritiesNavbar">
                    {{ translation.translate("Home", "peculiaritiesNavbar") }}
                  </li></a
                  >
                  <a href="#contact"
                  ><li class="nav-item lng-contactNavbar">
                    {{ translation.translate("Home", "contactNavbar") }}
                  </li></a
                  >
                  <select
                      @change="_onChangeLanguage"
                      v-model="localLanguage"
                      class="change-select"
                  >
                    <option value="ru" selected>Ру</option>
                    <option value="uz">Уз</option>
                    <option value="oz">O'z</option>
                  </select>
                </ul>

                <router-link to="app">
                  <button class="btn-sign-in lng-sign">
                    {{ translation.translate("Home", "sign") }}
                  </button>
                </router-link
                >
              </div>
            </div>
            <transition name="slide-fade">
              <div v-show="mobileMenu" v-cloak class="navbar-collapse">
                <ul class="navbarMobile">
                  <a href="#Possibilities"
                  ><li class="nav-item lng-possibilitiesNavbar1">
                    {{ translation.translate("Home", "possibilitiesNavbar") }}
                  </li></a
                  >
                  <div class="TheLine"></div>
                  <a href="#Peculiarities"
                  ><li class="nav-item lng-peculiaritiesNavbar1">
                    {{ translation.translate("Home", "peculiaritiesNavbar") }}
                  </li></a
                  >
                  <div class="TheLine"></div>
                  <a href="#contact"
                  ><li class="nav-item lng-contactNavbar1">
                    {{ translation.translate("Home", "contactNavbar") }}
                  </li></a
                  >
                  <div class="TheLine"></div>
                  <select
                      @change="_onChangeLanguage"
                      v-model="localLanguage"
                      class="change-select"
                  >
                    <option value="ru" selected>Ру</option>
                    <option value="uz">Уз</option>
                    <option value="oz">O'z</option>
                  </select>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </header>

    <!-- main box -->
    <main>
      <div class="linkWithUs">
        <div class="number-slide-out">
          <transition name="slide-fade-num">
            <span v-show="showNumber" class="number">(71) 200-00-13</span>
          </transition>
          <div
              class="link-phone"
              @mouseleave="hideNumberFunction"
              @mouseover="showNumberFunction"
          >
            <a href="tel: 71 200 00 13">
              <svg
                  width="50"
                  height="50"
                  viewBox="0 0 38 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <circle cx="19" cy="19" r="19" fill="#72BD49" />
                <rect
                    x="10.4314"
                    y="10.4314"
                    width="17.8824"
                    height="17.1373"
                    fill="url(#pattern0)"
                />
                <defs>
                  <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                  >
                    <use
                        xlink:href="#image0"
                        transform="translate(-0.130435 -0.136364) scale(0.00630435 0.00659091)"
                    />
                  </pattern>
                  <image
                      id="image0"
                      width="200"
                      height="200"
                      xlink:href="data:image/png;base64,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"
                  />
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div class="link-telegram">
          <a href="https://t.me/fakturauz">
            <svg
                enable-background="new 0 0 100 100"
                width="50px"
                height="50px"
                id="Layer_1"
                version="1.1"
                viewBox="0 0 100 100"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g>
                <circle cx="50" cy="50" fill="#139BD0" r="45" />
                <path
                    clip-rule="evenodd"
                    d="M51.474,60.754c-1.733,1.688-3.451,3.348-5.153,5.021   c-0.595,0.586-1.264,0.91-2.118,0.865c-0.583-0.031-0.909-0.287-1.088-0.84c-1.304-4.047-2.627-8.084-3.924-12.135   c-0.126-0.393-0.312-0.584-0.71-0.707c-3.072-0.938-6.138-1.898-9.199-2.871c-0.471-0.15-0.946-0.346-1.353-0.623   c-0.629-0.426-0.721-1.121-0.157-1.621c0.521-0.461,1.143-0.863,1.789-1.119c3.755-1.488,7.53-2.928,11.299-4.381   c9.565-3.693,19.13-7.383,28.696-11.076c1.819-0.703,3.217,0.287,3.028,2.254c-0.121,1.258-0.447,2.496-0.71,3.738   c-2.077,9.807-4.156,19.615-6.244,29.42c-0.496,2.328-2.131,2.936-4.047,1.523c-3.209-2.365-6.415-4.738-9.622-7.107   C51.808,60.984,51.649,60.877,51.474,60.754z M44.271,63.732c0.036-0.01,0.072-0.02,0.108-0.029   c0.02-0.092,0.049-0.182,0.057-0.273c0.206-2.223,0.424-4.445,0.603-6.672c0.04-0.496,0.21-0.848,0.583-1.182   c2.958-2.645,5.898-5.307,8.844-7.963c3.261-2.941,6.523-5.879,9.772-8.832c0.201-0.182,0.285-0.492,0.423-0.744   c-0.306-0.033-0.634-0.156-0.912-0.084c-0.379,0.098-0.738,0.318-1.076,0.531c-7.197,4.533-14.388,9.074-21.59,13.598   c-0.407,0.256-0.483,0.473-0.328,0.92c0.531,1.525,1.014,3.064,1.515,4.6C42.937,59.646,43.604,61.689,44.271,63.732z"
                    fill="#FFFFFF"
                    fill-rule="evenodd"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>
    </main>

    <!-- section -->
    <section>
      <div class="Main-frame">
        <div class="container">
          <div class="row">
            <div class="frame-block">
              <div class="frame-info">
                <h1 class="lng-frameTitle" id="Possibilities">
                  {{ translation.translate("Home", "frameTitle") }}
                </h1>
                <p class="lng-servise-info">
                  {{ translation.translate("Home", "servise-info") }}
                </p>
                <router-link
                    to="app"
                    class="frameBtn lng-btnTry d-inline-block"
                >{{ translation.translate("Home", "btnTry") }}</router-link
                >
              </div>
              <div class="frameMain-image">
                <img
                    src="../assets/images/Slider-EDI.png"
                    alt="Slider.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="Main-service">
        <div class="container">
          <div class="row">
            <div class="information-Inservice">
              <h2 class="lng-servise">
                {{ translation.translate("Home", "servise") }}
              </h2>
              <p class="lng-information-serve">
                {{ translation.translate("Home", "information-serve") }}
              </p>
            </div>
            <div class="info-image">
              <img src="../assets/images/serice-EDI.png" alt="png" />
            </div>
          </div>
        </div>
      </div>

      <div class="card-blog">
        <div class="container">
          <div class="row card-box">
            <div class="col-lg-5 col-md-12">
              <div class="card-item">
                <h5 class="lng-red-box-h5">
                  {{ translation.translate("Home", "red-box-h5") }}
                </h5>
                <ul>
                  <li class="lng-forms-red-box">
                    {{ translation.translate("Home", "forms-red-box") }}
                  </li>
                  <li class="lng-takes-red-box">
                    {{ translation.translate("Home", "takes-red-box") }}
                  </li>
                  <li class="lng-send-red-box">
                    {{ translation.translate("Home", "send-red-box") }}
                  </li>
                  <li class="lng-accounting-red-box">
                    {{ translation.translate("Home", "accounting-red-box") }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-5 col-md-12">
              <div class="card-item-blue">
                <h5 class="lng-blue-box-h5">
                  {{ translation.translate("Home", "blue-box-h5") }}
                </h5>
                <ul>
                  <li class="lng-forms-blue-box">
                    {{ translation.translate("Home", "forms-blue-box") }}
                  </li>
                  <li class="lng-takes-blue-box">
                    {{ translation.translate("Home", "takes-blue-box") }}
                  </li>
                  <li class="lng-directs-blue-box">
                    {{ translation.translate("Home", "directs-blue-box") }}
                  </li>
                  <br />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="Peculiarities-Block">
        <div class="container">
          <h2 id="Peculiarities" class="lng-Peculiarities">
            {{ translation.translate("Home", "Peculiarities") }}
          </h2>
          <div class="row Peculiarities-box">
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-box-seam"></i>
                <p class="lng-Simplicity">
                  {{ translation.translate("Home", "Simplicity") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-file-earmark-check"></i>
                <p class="lng-settings">
                  {{ translation.translate("Home", "settings") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-collection"></i>
                <p class="lng-Operational">
                  {{ translation.translate("Home", "Operational") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-check-all"></i>
                <p class="lng-development">
                  {{ translation.translate("Home", "development") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-bar-chart-fill"></i>
                <p class="lng-opportunities">
                  {{ translation.translate("Home", "opportunities") }}
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <div class="Peculiarities-item">
                <i class="bi bi-chat-fill"></i>
                <p class="lng-skills">
                  {{ translation.translate("Home", "skills") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="PriceBlock">
          <div class="container">
            <h2 id="price" class="lng-price">Цена</h2>
            <div class="row">
              <div class="price-container">
                <div class="PriceBlog">
                  <div class="price-box">
                    <h3 class="lng-freePrice"></h3>
                    <button class="price-b lng-price-card">0 Сум</button>
                    <div class="TheLine"></div>
                    <ul>
                      <li class="mt-3">
                        <i class="bi bi-check-circle-fill"></i><span class="lng-Creations"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-requests"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-orders"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-organization"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-users"></span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="PriceBlog mt40  ">
                  <div class="price-box">
                    <h3 class="lng-freePrice1"></h3>
                    <button class="price-b lng-price-card1">0 Сум</button>
                    <div class="TheLine"></div>
                    <ul>
                      <li class="mt-3">
                        <i class="bi bi-check-circle-fill"></i><span class="lng-Creations1"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-requests1"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-orders1"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-organization1"></span>
                      </li>
                      <li>
                        <i class="bi bi-check-circle-fill"></i><span class="lng-users1"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
    </section>

    <!-- footer -->
    <footer>
      <div class="container">
        <div class="row">
          <div class="Contact-footer">
            <h3 id="contact">
              <img src="../assets/images/call.png" alt="icon" /> +998
              71 200 00 13
            </h3>
            <p class="lng-location-info">
              {{ translation.translate("Home", "location-info") }}
            </p>
            <p class="lng-info-end">
              {{ translation.translate("Home", "info-end") }}
            </p>
            <div class="socialMedia">
              <div class="contact-item">
                <a href="https://www.instagram.com/faktura.uz/?hl=ru">
                  <svg
                      enable-background="new 0 0 128 128"
                      width="35px"
                      height="35px"
                      id="Layer_1"
                      version="1.1"
                      viewBox="0 0 128 128"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <linearGradient
                          gradientTransform="matrix(1 0 0 -1 594 633)"
                          gradientUnits="userSpaceOnUse"
                          id="SVGID_1_"
                          x1="-566.7114"
                          x2="-493.2875"
                          y1="516.5693"
                          y2="621.4296"
                      >
                        <stop offset="0" style="stop-color: #ffb900" />
                        <stop offset="1" style="stop-color: #9100eb" />
                      </linearGradient>
                      <circle cx="64" cy="64" fill="url(#SVGID_1_)" r="64" />
                    </g>
                    <g>
                      <g>
                        <path
                            d="M82.333,104H45.667C33.72,104,24,94.281,24,82.333V45.667C24,33.719,33.72,24,45.667,24h36.666    C94.281,24,104,33.719,104,45.667v36.667C104,94.281,94.281,104,82.333,104z M45.667,30.667c-8.271,0-15,6.729-15,15v36.667    c0,8.271,6.729,15,15,15h36.666c8.271,0,15-6.729,15-15V45.667c0-8.271-6.729-15-15-15H45.667z"
                            fill="#FFFFFF"
                        />
                      </g>
                      <g>
                        <path
                            d="M64,84c-11.028,0-20-8.973-20-20c0-11.029,8.972-20,20-20s20,8.971,20,20C84,75.027,75.028,84,64,84z     M64,50.667c-7.352,0-13.333,5.981-13.333,13.333c0,7.353,5.981,13.333,13.333,13.333S77.333,71.353,77.333,64    C77.333,56.648,71.353,50.667,64,50.667z"
                            fill="#FFFFFF"
                        />
                      </g>
                      <g>
                        <circle
                            cx="85.25"
                            cy="42.75"
                            fill="#FFFFFF"
                            r="4.583"
                        />
                      </g>
                    </g></svg
                  ></a>
              </div>
              <div class="contact-item">
                <a
                    href="https://www.youtube.com/channel/UCJwAsKcNAoX083ByjSgkBRg"
                >
                  <svg
                      enable-background="new 0 0 48 48"
                      id="Layer_1"
                      width="35px"
                      height="35px"
                      version="1.1"
                      viewBox="0 0 48 48"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <circle cx="24" cy="24" fill="#CA3737" r="24" />
                    <path
                        d="M35.2,18.5c0-0.1,0-0.2-0.1-0.3c0,0,0-0.1,0-0.1c-0.3-0.9-1.1-1.5-2.1-1.5h0.2c0,0-3.9-0.6-9.2-0.6  c-5.2,0-9.2,0.6-9.2,0.6H15c-1,0-1.8,0.6-2.1,1.5c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.3c-0.1,1-0.4,3.1-0.4,5.5  c0,2.4,0.3,4.5,0.4,5.5c0,0.1,0,0.2,0.1,0.3c0,0,0,0.1,0,0.1c0.3,0.9,1.1,1.5,2.1,1.5h-0.2c0,0,3.9,0.6,9.2,0.6  c5.2,0,9.2-0.6,9.2-0.6H33c1,0,1.8-0.6,2.1-1.5c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0.1-1,0.4-3.1,0.4-5.5  C35.6,21.6,35.4,19.5,35.2,18.5z M27.4,24.5l-4.7,3.4C22.6,28,22.5,28,22.4,28c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.3-0.3-0.5v-6.8  c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6,0l4.7,3.4c0.1,0.1,0.2,0.3,0.2,0.5C27.7,24.2,27.6,24.4,27.4,24.5z"
                        fill="#FFFFFF"
                    />
                  </svg>
                </a>
              </div>
              <div class="contact-item">
                <a href="https://facebook.com/fakturauz">
                  <svg
                      width="35px"
                      height="35px"
                      style="
                      fill-rule: evenodd;
                      clip-rule: evenodd;
                      stroke-linejoin: round;
                      stroke-miterlimit: 2;
                    "
                      version="1.1"
                      viewBox="0 0 512 512"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:serif="http://www.serif.com/"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <path
                          d="M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z"
                          style="fill: #1877f2; fill-rule: nonzero"
                      />
                      <path
                          d="M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z"
                          style="fill: #fff; fill-rule: nonzero"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <div class="contact-item">
                <a href="https://t.me/fakturauz">
                  <svg
                      enable-background="new 0 0 100 100"
                      width="40px"
                      height="40px"
                      id="Layer_1"
                      version="1.1"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <circle cx="50" cy="50" fill="#139BD0" r="45" />
                      <path
                          clip-rule="evenodd"
                          d="M51.474,60.754c-1.733,1.688-3.451,3.348-5.153,5.021   c-0.595,0.586-1.264,0.91-2.118,0.865c-0.583-0.031-0.909-0.287-1.088-0.84c-1.304-4.047-2.627-8.084-3.924-12.135   c-0.126-0.393-0.312-0.584-0.71-0.707c-3.072-0.938-6.138-1.898-9.199-2.871c-0.471-0.15-0.946-0.346-1.353-0.623   c-0.629-0.426-0.721-1.121-0.157-1.621c0.521-0.461,1.143-0.863,1.789-1.119c3.755-1.488,7.53-2.928,11.299-4.381   c9.565-3.693,19.13-7.383,28.696-11.076c1.819-0.703,3.217,0.287,3.028,2.254c-0.121,1.258-0.447,2.496-0.71,3.738   c-2.077,9.807-4.156,19.615-6.244,29.42c-0.496,2.328-2.131,2.936-4.047,1.523c-3.209-2.365-6.415-4.738-9.622-7.107   C51.808,60.984,51.649,60.877,51.474,60.754z M44.271,63.732c0.036-0.01,0.072-0.02,0.108-0.029   c0.02-0.092,0.049-0.182,0.057-0.273c0.206-2.223,0.424-4.445,0.603-6.672c0.04-0.496,0.21-0.848,0.583-1.182   c2.958-2.645,5.898-5.307,8.844-7.963c3.261-2.941,6.523-5.879,9.772-8.832c0.201-0.182,0.285-0.492,0.423-0.744   c-0.306-0.033-0.634-0.156-0.912-0.084c-0.379,0.098-0.738,0.318-1.076,0.531c-7.197,4.533-14.388,9.074-21.59,13.598   c-0.407,0.256-0.483,0.473-0.328,0.92c0.531,1.525,1.014,3.064,1.515,4.6C42.937,59.646,43.604,61.689,44.271,63.732z"
                          fill="#FFFFFF"
                          fill-rule="evenodd"
                      />
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import translate from "../translation/translate";
import _ from "underscore";
import SessionStorage from "sessionstorage";
import QueryString from "querystring";
import AuthService from "@/services/auth.service";
import * as Settings from "@/settings";

export default {
  name: "app",
  component: {},
  data() {
    return {
      translation: translate,
      localLanguage: "ru",
      mobileMenu: false,
      isScrolled: false,
      scrolled: false,
      scrollPosition: null,
      limitPosition: 500,
      lastPosition: 0,
      showNumber: false,
    };
  },
  methods: {
    _onChangeLanguage(event) {
      translate.changeLocale(event.target.value);
      this.$emit("changeLang", event.target.value);
    },
    showMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
    },
    showNumberFunction() {
      this.showNumber = true;
    },
    hideNumberFunction() {
      this.showNumber = false;
    },
    updateScroll() {
      /* eslint-disable no-debugger */
      this.scrollPosition = window.scrollY;

      if (this.scrollPosition > 10) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }

      if (this.scrollPosition < 20) {
        this.isTopHeader = true;
      } else {
        this.isTopHeader = false;
      }
    },

    handleScroll() {
      if (
          this.lastPosition < window.scrollY &&
          this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }

      if (this.lastPosition > window.scrollY) {
        this.scrolled = false;
        // move down
      }

      this.lastPosition = window.scrollY;
      // this.scrolled = window.scrollY > 250;
    },

    auth() {
      const queryParams = {};
      _.each(window.location.search.replace('?', '')
          .split('&'), p => {
        const kv = p.split('=');
        queryParams[kv[0]] = kv[1];
      });

      // authorization code
      if (typeof (queryParams["code"]) === 'string' && queryParams["code"].length > 10) {
        AuthService.loginByAuthorizationCode(queryParams["code"])
            .then(response => {
              let token = response.data;
              token.issued = new Date().toISOString();
              SessionStorage.setItem("auth_token", JSON.stringify(token))

              window.location.href = window.location.origin + '#/app/main'
            })
            .catch(() => {
              this.redirectToLogin()
            });
      }
    },
    redirectToLogin() {
      let qs = QueryString.stringify({
        response_type: 'code',
        client_id: Settings.AccountFakturaClientId,
        redirect_uri: `${window.location.origin}`
      });

      window.location.href = `${Settings.AccountFakturaHostUrl}/Authorize?${qs}`;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  created() {
    if (window.scrollY == 0) {
      this.isTopHeader = true;
    } else {
      this.isTopHeader = false;
    }
    let storageClient = JSON.parse(localStorage.getItem("translation"));
    if (storageClient) {
      this.localLanguage = storageClient.localeName
    }

    this.auth()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
/*@import "https://bootstrap-vue/dist/bootstrap-vue.css";*/
@import "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap";
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css";
@import "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.2/font/bootstrap-icons.css";
/*@import "https://fonts.gstatic.com";*/
/*@import "https://fonts.googleapis.com";*/

* {
  font-family: "Montserrat", sans-serif;
}

body {
  background: url("https://faktura.uz/img/background-White.094addbb.png");
  background-size: cover;
}

/* ====== call ===== */
[v-cloak] {
  display: none;
}
.box-call-center {
  position: static;
  width: 100%;
  height: auto;
  background: #eefbff;
  padding: 5px 18px;
  display: none;
}
.call-center .item-call img {
  width: 15px;
  height: 15px;
}

.call-center .item-call span {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: #616161;
  margin-left: 7px;
}
.call-center .item-call a {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: #616161;
}

/* ====== call end ===== */

a {
  text-decoration: none;
}

#header {
  will-change: transform;
  transition: transform 200ms linear;
  background-repeat: repeat-x;
}

/* ============================ */
.bi-list {
  color: #17c1fe;
  font-size: 24px;
  margin-right: 10px;
  cursor: pointer;
}
header .container-navbar {
  background: white;
  padding: 30px 0;
}
header .container-navbar .container .nav-block .logo-navbar .Vector {
  margin-right: 15px;
}
header .container-navbar .container .nav-block .navbar-box ul {
  width: 450px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}
header .container-navbar .container .nav-block .navbar-box ul li {
  list-style: none;
  font-size: 15px;
  color: #888888;
  font-weight: 500;
  transition: 300ms;
}

header .container-navbar .container .nav-block .navbar-box ul li:hover {
  color: #17c1fe;
  font-weight: 500;
  cursor: pointer;
}

header .container-navbar .container .nav-block .btn-sign-in {
  background: transparent !important;
  color: #17c1fe;
  font-weight: 500;
  border-radius: 30px;
  border: 2px solid #17c1fe;
  background: white;
  padding: 5px 30px;
  transition: 500ms;
  margin-left: 25px;
}

header .container-navbar .container .nav-block .btn-sign-in:hover {
  color: white;
  background: #17c1fe !important;
  box-shadow: 0 0 12px #17c1fe;
}

.navbarMobile {
  padding: 0;
}

/* ===== fixed elements Link With Us ====== */

main .linkWithUs {
  position: fixed;
  bottom: 20px;
  right: 30px;
  display: flex;
  justify-content: end;
  align-items: center;
}

.linkWithUs .link-phone svg {
  border-radius: 50%;
  background-color: #72bd49;
  margin-right: 10px;
  box-shadow: 0 0 3px #72bd49;
}

.linkWithUs .link-phone svg:hover {
  box-shadow: 0 0 4px #72bd49;
}

.linkWithUs .link-telegram svg {
  border-radius: 50%;
  box-shadow: 0 0 5px grey;
}

.number {
  display: block;
  width: 170px;
  padding: 13px 30px 13px 10px;
  background: rgba(90, 169, 47, 1);
  color: white;
  box-shadow: 0 0 10px rgba(90, 169, 47, 1);
  border-radius: 22px;
  font-size: 16px;
  margin-right: -38px;
  font-weight: 500;
}

.slide-fade-num-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-num-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-num-enter, .slide-fade-num-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(16px);
  opacity: 0;
}

/* ===== Mobile version Navbar ===== */

.navbar-collapse {
  margin-top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: white;
}

.nav-item {
  list-style: none;
  font-size: 15px;
  color: #888888;
  font-weight: 500;
  transition: 300ms;
}

.nav-item:hover {
  color: #17c1fe;
  font-weight: 500;
  cursor: pointer;
}

/* ====== Slider ===== */

section .Main-frame {
  width: 100%;
  height: 586px;
  background: #eefbff;
  display: flex;
  align-items: center;
}

section .Main-frame .container .frame-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

section .Main-frame .container .frame-block .frame-info h1 {
  width: 460px;
  font-size: 35px;
  font-weight: 600;
  color: #222224;
  margin-bottom: 20px;
}

section .Main-frame .container .frame-block .frame-info p {
  width: 75%;
  font-size: 22px;
  color: #222222;
  font-weight: 400;
  line-height: 30px;
}

section .Main-frame .container .frame-block .frame-info .frameBtn {
  color: white;
  padding: 8px 30px;
  border: none;
  border-radius: 30px;
  background: #17c1fe;
  margin-top: 20px;
  transition: 500ms;
}

section .Main-frame .container .frame-block .frame-info .frameBtn:hover {
  box-shadow: 0 0 12px #17c1fe;
}

.TheLine {
  width: 100%;
  height: 1px;
  background: #dddddd;
  margin: 5px auto;
}

/* ===== main ===== */
.Main-service .container .information-Inservice {
  margin: auto;
}

h2 {
  margin-top: 50px;
  text-align: center;
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
  color: #5b5b5b;
}

/* #177fc0 */

.Main-service .container .information-Inservice p {
  width: 45%;
  margin: 25px auto 0;
  text-align: center;
  font-size: 19px;
  line-height: 22px;
  font-weight: 400;
  color: #676767;
}

.Main-service .container .info-image {
  margin: 100px auto 0;
  display: flex;
  justify-content: center;
}

.Main-service .container .info-image img {
  width: 930px;
  height: 428px;
}

/* ===== Section Bot ===== */

.Possibilities .container h3 {
  color: #5b5b5b;
  font-size: 28px;
  margin: 50px 0;
}

.Possibilities .container .center-blog {
  display: flex;
  justify-content: center;
}

.Possibilities .container .center-blog img {
  width: 269px;
  height: 546px;
}

.Possibilities .container .left-blog .info-item-left h2 {
  text-align: end;
  color: #17c1fe;
  font-size: 28px;
  font-weight: 500;
  margin-top: 30px;
}

.Possibilities .container .left-blog .info-item-left p {
  text-align: end;
  font-weight: 400;
  font-size: 17px;
  color: #323232;
  margin-bottom: 70px;
  padding-left: 100px;
}

/* ====== */
.Possibilities .container .right-blog .info-item-right h2 {
  text-align: start;
  color: #17c1fe;
  font-size: 28px;
  font-weight: 500;
  margin-top: 30px;
}

.Possibilities .container .right-blog .info-item-right p {
  text-align: start;
  font-weight: 400;
  font-size: 17px;
  color: #323232;
  margin-bottom: 70px;
  padding-right: 100px;
}

/* ===== Cards ===== */

.card-blog .container .card-box {
  width: 100%;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}

.card-blog .container .card-item {
  width: 100%;
  height: 250px;
  background: #dd5444;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px #dd5444;
}

.card-blog .container .card-item h5 {
  color: white;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
}

.card-blog .container .card-item ul li {
  color: white;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
}

/* ===== */

.card-blog .container .card-item-blue {
  width: 100%;
  height: 250px;
  background: #177fc0;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px #177fc0;
}

.card-blog .container .card-item-blue h5 {
  color: white;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
}

.card-blog .container .card-item-blue ul li {
  color: white;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
}

/* ===== Peculiarities ===== */

.Peculiarities-Block .container h2 {
  text-align: center;
  margin: 50px 0;
  color: #5b5b5b;
}

.Peculiarities-Block .container .Peculiarities-item {
  width: 280px;
  height: 145px;
  box-sizing: border-box;
  margin: 20px auto;
  background: #eefbff;
  box-shadow: 0 0 20px rgb(0 0 0/15%) !important;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Peculiarities-Block .container .Peculiarities-item i {
  font-size: 30px;
  color: #177fc0;
}

.Peculiarities-Block .container .Peculiarities-item p {
  text-align: center;
  color: #555555;
  font-size: 16px;
  margin-top: 8px;
  line-height: 18px;
}

/* ===== Price ===== */

.PriceBlock .container h2 {
  font-size: 28px;
  text-align: center;
  margin: 50px auto;
  color: #5b5b5b;
}

.PriceBlock .container .PriceBlog .price-box {
  width: 268px;
  height: auto;
  margin: auto;
  box-shadow: 0 0 10px grey;
  padding: 30px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.PriceBlock .container .price-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: auto;
  width: 650px;
}

.PriceBlock .container .PriceBlog .price-box h3 {
  text-align: center;
  color: #5b5b5b;
  font-size: 19px;
  font-weight: 500;
}

.PriceBlock .container .PriceBlog .price-box .price-b {
  margin: 15px auto;
  font-size: 15px;
  font-weight: 500;
  padding: 5px 40px;
  background: #17c1fe;
  color: white;
  border: none;
  border-radius: 13px;
  box-shadow: 0 0 6px #17c1fe;
}

.TheLine {
  width: 100%;
  background: #dddddd;
  margin: 5px auto;
}

.PriceBlock .container .PriceBlog .price-box ul {
  padding-left: 0;
}

.PriceBlock .container .PriceBlog .price-box ul li {
  font-size: 10px;
  color: #8a8a99;
  line-height: 25px;
  list-style: none;
}

.PriceBlock .container .PriceBlog .price-box i {
  color: #17c1fe;
  margin-right: 5px;
}

/* ===== footer ====== */
footer .container img {
  width: 18px;
  height: 18px;
}

footer .container .Contact-footer {
  margin: 100px auto;
}

footer .container .Contact-footer h3 {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: #4a4a4a;
}

footer .container .Contact-footer p {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #939393;
}

.bi-telephone-fill {
  font-size: 18px;
}
/* === social media === */

.socialMedia {
  width: 230px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}

/* ===== form selection ===== */

.change-select {
  background: transparent !important;
  border: none;
  outline: none !important;
  box-shadow: none !important;
  font-size: 15px !important;
  color: #888888 !important;
  font-weight: 500 !important;
  transition: 300ms;
}

.change-select:hover {
  color: #177fc0 !important;
  cursor: pointer !important;
}

.headroom--unpinned {
  transform: translateY(-100%);
}

.headroom {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99999;
}

.headroom .sign-in-link {
  background-color: #72bd49;
}

#headroom .authorization-block {
  background-color: #3f5872 !important;
}

.isTopHeader {
  position: relative !important;
  z-index: 999;
}

.headroom .main-menu {
  background-color: #3f5872 !important;
}

.headroom .logo-block {
  background-color: #3f5872 !important;
}

.headroom--unpinned {
  transform: translateY(-100%);
}

.headroom--pinned {
  transform: translateY(0%);
}

.number-slide-out {
  position: relative;
}

.number {
  position: absolute;
  left: -126px;
  z-index: -1;
}

/* ------ Vector ------ */

.vector-in-img {
  width: 40%;
  height: auto;
  text-align: start;
}
.btn-vector {
  border: none;
  background: transparent;
}
.InVector-item {
  width: 100%;
  padding: 10px 5px !important;
}
.InVector-item:hover {
  background: whitesmoke;
}
.InVector-item-uz {
  width: 100%;
}
.InVector-item-uz:hover {
  background: whitesmoke;
}
.theLine--InVector {
  width: 85% !important;
  margin: 2px auto !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.dropdown-item:hover {
  background: transparent !important;
}
.dropdown-menu {
  min-width: 12rem !important;
}
.dropdown-menu.show {
  transform: translate(0px, 40px) !important;
  border: none;
  box-shadow: 0 24px 48px rgb(0 0 0 / 15%);
  width: 550px;
  padding: 10px 20px;
  border-radius: 15px;
}
.InVector-description {
  margin: 0;
  padding: 10px 5px 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #222224;
}
@media (max-width: 1199px) {
  .Possibilities .container .left-blog .info-item-left p {
    padding-left: 50px;
    margin-bottom: 10px;
  }

  .Possibilities .container .right-blog .info-item-right p {
    padding-right: 40px;
    margin-bottom: 10px;
  }
}

@media (max-width: 991px) {
  .Main-frame .container .frame-block .frameMain-image {
    display: none;
  }

  .Possibilities .container .center-blog {
    display: none;
  }

  .Possibilities .container .left-blog .info-item-left p {
    padding-left: 50px;
  }

  .Possibilities .container .right-blog .info-item-right p {
    padding-right: 40px;
  }

  header .container-navbar .container .nav-block .logo-navbar .Vector {
    display: none;
  }

  header .container-navbar .container .nav-block .navbar-box .box-menu {
    display: none;
  }

  section .Main-frame .container .frame-block .frame-info p {
    font-size: 20px;
    margin-bottom: 0px;
  }

  .Main-service .container .information-Inservice p {
    width: 100%;
  }

  .Main-service .container .info-image img {
    width: 520px;
    height: 250px;
  }

  .card-blog .container .card-item-blue {
    margin-top: 30px;
  }

  .card-blog .container .card-item {
    width: 100%;
    height: auto;
  }

  .card-blog .container .card-item-blue {
    width: 100%;
    height: auto;
  }
}

@media (min-width: 992px) {
  .bi-list {
    display: none;
  }
}

@media (max-width: 767px) {
  .Possibilities .container .left-blog .info-item-left h2 {
    text-align: center;
  }

  .Possibilities .container .left-blog .info-item-left p {
    text-align: center;
    padding: 0px;
  }

  .Possibilities .container .right-blog .info-item-right h2 {
    text-align: center;
  }

  .Possibilities .container .right-blog .info-item-right p {
    text-align: center;
    padding: 0px;
  }

  .PriceBlock .container .PriceBlog .price-box {
    width: 290px;
  }

  .Peculiarities-Block .container .Peculiarities-item {
    width: 240px;
    height: 145px;
    padding: 15px;
  }

  section .Main-frame {
    height: 400px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    width: 95%;
    line-height: 24px;
    margin-bottom: 0px;
  }

  .Main-service .container .information-Inservice p {
    font-size: 14px;
  }
  .Main-service .container .info-image img {
    width: 100%;
    height: 100%;
  }
  .Peculiarities-Block .container .Peculiarities-item p {
    font-size: 14px;
    line-height: 16px;
  }

  .PriceBlock .container .PriceBlog .price-box {
    width: 230px;
    height: auto;
  }

  .PriceBlock .container .price-container {
    width: 100%;
  }

  .PriceBlock .container .PriceBlog .price-box .price-b {
    font-size: 12px !important;
  }
}

@media (max-width: 576px) {
  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    width: 80%;
    margin-bottom: 0;
  }

  .Main-service .container .information-Inservice p {
    width: 90%;
    font-size: 14px;
    margin: 10px auto 0;
    line-height: 18px;
  }

  .Main-service .container .info-image img {
    width: 400px;
    height: 230px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    font-size: 16px;
  }

  .PriceBlock .container .price-container {
    display: block;
    margin: auto;
  }

  .mt40 {
    margin-top: 40px !important;
  }
}

@media (max-width: 576px) and (min-width: 400px) {
  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 35px;
  }

  .Peculiarities-Block .container .Peculiarities-item {
    width: 180px;
    height: 110px;
    padding: 15px;
  }

  .Peculiarities-Block .container .Peculiarities-item i {
    font-size: 24px;
  }

  .Peculiarities-Block .container .Peculiarities-item p {
    font-size: 10px;
    line-height: 14px;
  }

  .Possibilities .container h2 {
    font-size: 26px;
  }

  .Possibilities .container .left-blog .info-item-left h2 {
    font-size: 26px;
    margin: 20px 0 20px 0;
  }

  .Possibilities .container .left-blog .info-item-left p {
    font-size: 18px;
  }

  .Possibilities .container .right-blog .info-item-right h2 {
    font-size: 22px;
  }

  .Possibilities .container .right-blog .info-item-right p {
    font-size: 18px;
  }
}

@media (max-width: 400px) and (min-width: 320px) {
  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 20px;
    width: 260px;
  }

  section .Main-frame {
    height: 300px;
  }

  section .Main-frame .container .frame-block {
    padding-left: 32px;
  }

  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 16px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    font-size: 11px;
    line-height: 14px;
    margin-bottom: 0px;
  }

  section .Main-frame .container .frame-block .frame-info .frameBtn {
    font-size: 14px;
    padding: 8px 20px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    width: 80%;
    font-size: 12px;
    line-height: 20px;
  }

  .Peculiarities-Block .container .Peculiarities-item {
    width: 140px;
    height: 100px;
    padding: 15px;
  }

  .Peculiarities-Block .container .Peculiarities-item i {
    font-size: 20px;
  }

  .Peculiarities-Block .container .Peculiarities-item p {
    font-size: 8px;
    line-height: 11px;
  }

  .logo {
    width: 150px;
    height: auto;
  }

  header .container-navbar .container .nav-block .btn-sign-in {
    padding: 2px 15px;
    margin-right: 20px;
  }

  .box-call-center {
    display: block;
  }

  section .Main-frame {
    height: 300px;
  }

  section .Main-frame .container .frame-block {
    padding-left: 32px;
  }

  .number-slide-out {
    display: none;
  }

  header .container-navbar {
    background: white;
    padding: 15px 0;
  }

  .Main-service .container .info-image img {
    width: 100%;
    height: 100%;
  }

  .Main-service .container .information-Inservice p {
    line-height: 16px;
    font-size: 12px;
    width: 100%;
  }

  .Main-service .container .info-image {
    margin-top: 25px;
  }

  .Main-service .container .info-image img {
    width: 100%;
    height: 100%;
  }

  .card-blog .container .card-item h5 {
    font-size: 18px;
  }

  .card-blog .container .card-item-blue h5 {
    font-size: 18px;
  }

  .card-blog .container .card-item ul li {
    font-size: 12px;
    line-height: 18px;
  }
  .card-blog .container .card-item-blue ul li {
    font-size: 12px;
    line-height: 18px;
  }

  .card-blog .container .card-item {
    width: 100%;
    height: auto;
    padding: 15px;
  }

  .card-blog .container .card-item-blue {
    width: 100%;
    height: auto;
    padding: 15px;
  }
}

@media (max-width: 320px) {
  .number-slide-out {
    display: none;
  }

  .PriceBlock .container .PriceBlog .price-box {
    width: 290px;
  }

  .PriceBlock .container .PriceBlog .price-box ul {
    padding: 0 !important;
  }

  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 23px;
    width: 240px;
  }

  section .Main-frame .container .frame-block .frame-info ul li {
    font-size: 15px;
  }

  .Peculiarities-Block .container .Peculiarities-item {
    width: 140px;
    height: 100px;
    padding: 15px;
  }

  .Peculiarities-Block .container .Peculiarities-item i {
    font-size: 20px;
  }

  .Peculiarities-Block .container .Peculiarities-item p {
    font-size: 8px;
    line-height: 11px;
  }

  .Possibilities .container h2 {
    font-size: 22px;
  }

  .Possibilities .container .left-blog .info-item-left h2 {
    font-size: 22px;
    margin: 20px 0 20px 0;
  }

  .Possibilities .container .left-blog .info-item-left p {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .Possibilities .container .right-blog .info-item-right h2 {
    font-size: 22px;
  }

  .Possibilities .container .right-blog .info-item-right p {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .Peculiarities-Block .container h2 {
    font-size: 28px;
  }

  .logo {
    width: 150px;
    height: auto;
  }

  header .container-navbar .container .nav-block .btn-sign-in {
    padding: 2px 15px;
    margin-right: 20px;
  }

  header .container-navbar {
    background: white;
    padding: 15px 0;
  }

  section .Main-frame .container .frame-block .frame-info h1 {
    font-size: 16px;
  }

  section .Main-frame .container .frame-block .frame-info p {
    font-size: 11px;
    line-height: 14px;
    margin-bottom: 0px;
  }

  section .Main-frame .container .frame-block .frame-info .frameBtn {
    font-size: 14px;
    padding: 8px 20px;
  }

  .Main-service .container .info-image {
    margin-top: 25px;
  }

  .Main-service .container .info-image img {
    width: 100%;
    height: 100%;
  }

  .Main-service .container .information-Inservice p {
    line-height: 16px;
    font-size: 12px;
    width: 100%;
  }

  .card-blog .container .card-item h5 {
    font-size: 18px;
  }

  .card-blog .container .card-item-blue h5 {
    font-size: 18px;
  }

  .card-blog .container .card-item ul li {
    font-size: 12px;
    line-height: 18px;
  }
  .card-blog .container .card-item-blue ul li {
    font-size: 12px;
    line-height: 18px;
  }

  .card-blog .container .card-item {
    width: 100%;
    height: auto;
    padding: 15px;
  }

  .card-blog .container .card-item-blue {
    width: 100%;
    height: auto;
    padding: 15px;
  }
}
</style>